export var translateAlignProp = function translateAlignProp(alignProp) {
  switch (alignProp) {
    case 'start':
      return 'left';

    case 'end':
      return 'right';

    default:
      return alignProp;
  }
};